module.exports = __webpack_public_path__ + "img/p3.6a71ab4b.png";